import type { MetaData } from 'services/content/page/types/CFDailyPage'
import type * as DailyModule from '../types/DailyModule'
import { imageParser } from '../props/parsers/Image'

function featuredContentParser(
  dailyFeaturedContent: DailyModule.RawFeaturedContent,
): DailyModule.ParsedFeaturedContent | undefined {
  const { dailyFcCommentTopicId, headlineText } = dailyFeaturedContent

  const baseProps = {
    topicId: dailyFcCommentTopicId,
    headlineText,
  }

  switch (dailyFeaturedContent.type) {
    case 'image': {
      const { imageContent } = dailyFeaturedContent

      if (!imageContent) {
        return
      }

      const { image, button, link, captionText } = imageContent

      return {
        ...baseProps,
        type: 'image',
        imageContent: {
          ...imageParser(image),
          captionText,
          button,
          link,
        },
      }
    }
    case 'video': {
      const { videoContent } = dailyFeaturedContent
      const { youtubeVideoId, captionText } = videoContent
      return {
        ...baseProps,
        type: 'video',
        videoContent: {
          youtubeVideoId,
          captionText,
        },
      }
    }
  }
}

export default function dailyModuleComponentParser(
  rawComponent: DailyModule.Raw,
  metaData: MetaData,
): DailyModule.Parsed {
  const { nextUrl, previousUrl, slug, fullPath } = metaData

  const {
    previousDayLabelText,
    nextDayLabelText,
    workoutOfTheDay,
    featuredDailyLabelText,
    dailyFeaturedContent,
  } = rawComponent.dailyModule

  return {
    name: 'DailyModule',
    props: {
      fullPath,
      nextUrl,
      slug,
      previousUrl,
      previousDayLabelText,
      nextDayLabelText,
      featuredDailyLabelText,
      workoutOfTheDay: {
        ...workoutOfTheDay,
        isPreview: fullPath.endsWith('_preview'),
      },
      featuredContent: featuredContentParser(dailyFeaturedContent),
    },
  }
}
